<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="w-lg-65 text-center  mx-lg-auto mb-7">
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Leadin" tag-name="h1" :init="EditorConfig" />
                    </div>

                    <div class="position-relative">
                        <div class="row mb-5 justify-content-center">
                            <div class="col-lg-6 mb-4 mb-lg-0">
                                <!-- Card -->
                                <div class="card card-lg h-100 shadow-sm">
                                    <span class="badge bg-dark text-white card-pinned-top-end">
                                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.StandardPill" tag-name="span" :init="EditorConfig" />
                                    </span>

                                    <div class="card-body">
                                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.StandardDesc" :init="EditorConfig" />
                                        <!-- Media -->
                                        <div class="d-flex mb-3">


                                            <div class="flex-shrink-0" v-if="CourierConfig.courierFeeInitial && !CourierConfig.initialFeeIsPerLocation">
                                                <span class="display-4 lh-1 text-dark">${{(CourierConfig.courierFeeInitial + CourierConfig.courierFeePerMileStandard).toString().toSmartFixed(2)}}<span class="fs-4"> first mile</span></span>
                                            </div>
                                            <div class="flex-grow-1 align-self-end ms-3" v-if="CourierConfig.courierFeeInitial && !CourierConfig.initialFeeIsPerLocation">
                                                <span class="d-block" style="position:relative;top:-2px;">${{CourierConfig.courierFeePerMileStandard.toString().toSmartFixed(2)}} / mile thereafter</span>
                                            </div>


                                            <div class="flex-shrink-0" v-if="!CourierConfig.courierFeeInitial || CourierConfig.initialFeeIsPerLocation">
                                                <span class="display-4 lh-1 text-dark">${{CourierConfig.courierFeePerMileStandard.toString().toSmartFixed(2)}}<span class="fs-4"> per mile</span></span>
                                            </div>
                                            <div class="flex-grow-1 align-self-end ms-3" v-if="!CourierConfig.courierFeeInitial || CourierConfig.initialFeeIsPerLocation">
                                            </div>


                                        </div>
                                        <div class="d-flex mb-4">
                                            <div v-if="CourierConfig.courierFeeInitial && CourierConfig.initialFeeIsPerLocation">
                                                <span class="fs-5 text-muted" style="font-size: 10px !important;">+ ${{CourierConfig.courierFeeInitial.toString().toSmartFixed(2)}} flat fee per pick-up service call (regardless of number of articles).</span>
                                            </div>
                                        </div>
                                        <!-- End Media -->

                                        <div class="row">
                                            <div class="col-sm-12">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.StandardFeatures" :init="EditorConfig" />
                                                <!-- List Checked -->

                                                <div v-if="!CourierConfig.allowResidentialPickups" class="mt-5 text-red"><i class="bi-x-circle"></i> Residential pick-ups not available at this time</div>
                                                <!-- End List Checked -->
                                            </div>
                                            <!-- End Col -->
                                            <!-- End Col -->
                                        </div>
                                        <!-- End Row -->
                                    </div>

                                    <div class="card-footer pt-0">
                                        <div class="row align-items-center">
                                            <div class="col-sm-auto order-sm-2 mb-3 mb-sm-0">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.StandardCTARight" tag-name="span" :init="EditorConfig" />
                                            </div>
                                            <!-- End Col -->
                                            <div class="col">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.StandardCTALeft" tag-name="span" :init="EditorConfig" />
                                            </div>
                                            <!-- End Col -->
                                        </div>
                                        <!-- End Row -->
                                    </div>
                                </div>
                                <!-- End Card -->
                            </div>
                            <!-- End Col -->

                            <div v-if="CourierConfig.offerExpressDelivery" class="col-lg-6 mb-4 mb-lg-0">
                                <!-- Card -->
                                <div class="card card-lg h-100 shadow-sm">
                                    <span class="badge bg-primary text-white card-pinned-top-end">
                                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.ExpressPill" tag-name="span" :init="EditorConfig" />
                                    </span>

                                    <div class="card-body">
                                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.ExpressDesc" :init="EditorConfig" />
                                        <!-- Media -->
                                        <div class="d-flex mb-3">

                                            <div class="flex-shrink-0" v-if="CourierConfig.courierFeeInitial && !CourierConfig.initialFeeIsPerLocation">
                                                <span class="display-4 lh-1 text-dark">${{(CourierConfig.courierFeeInitial + CourierConfig.courierFeePerMileExpress).toString().toSmartFixed(2)}}<span class="fs-4"> first mile</span></span>
                                            </div>
                                            <div class="flex-grow-1 align-self-end ms-3" v-if="CourierConfig.courierFeeInitial && !CourierConfig.initialFeeIsPerLocation">
                                                <span class="d-block" style="position:relative;top:-2px;">${{CourierConfig.courierFeePerMileExpress.toString().toSmartFixed(2)}} / mile thereafter</span>
                                            </div>


                                            <div class="flex-shrink-0" v-if="!CourierConfig.courierFeeInitial || CourierConfig.initialFeeIsPerLocation">
                                                <span class="display-4 lh-1 text-dark">${{CourierConfig.courierFeePerMileExpress.toString().toSmartFixed(2)}}<span class="fs-4"> per mile</span></span>
                                            </div>
                                            <div class="flex-grow-1 align-self-end ms-3" v-if="!CourierConfig.courierFeeInitial || CourierConfig.initialFeeIsPerLocation">
                                            </div>


                                        </div>
                                        <div class="d-flex mb-4">
                                            <div v-if="CourierConfig.courierFeeInitial && CourierConfig.initialFeeIsPerLocation">
                                                <span class="fs-5 text-muted" style="font-size: 10px !important;">+ ${{CourierConfig.courierFeeInitial.toString().toSmartFixed(2)}} flat fee per pick-up service call (regardless of number of articles).</span>
                                            </div>
                                        </div>
                                        <!-- End Media -->

                                        <div class="row">
                                            <div class="col-sm-12">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.ExpressFeatures" :init="EditorConfig" />
                                                <!-- List Checked -->

                                                <div v-if="!CourierConfig.allowResidentialPickups" class="mt-5 text-red"><i class="bi-x-circle"></i> Residential pick-ups not available at this time</div>
                                                <!-- End List Checked -->
                                            </div>
                                            <!-- End Col -->
                                            <!-- End Col -->
                                        </div>
                                        <!-- End Row -->
                                    </div>

                                    <div class="card-footer pt-0">
                                        <div class="row align-items-center">
                                            <div class="col-sm-auto order-sm-2 mb-3 mb-sm-0">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.ExpressCTARight" tag-name="span" :init="EditorConfig" />
                                            </div>
                                            <!-- End Col -->
                                            <div class="col">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.ExpressCTALeft" tag-name="span" :init="EditorConfig" />
                                            </div>
                                            <!-- End Col -->
                                        </div>
                                        <!-- End Row -->
                                    </div>
                                </div>
                                <!-- End Card -->
                            </div>

                            <!-- End Col -->
                        </div>
                        <!-- End Row -->
                        <!-- SVG Shape -->
                        <figure v-if="!BlockProps.HideFlourish" class="position-absolute top-0 end-0 d-none d-md-block mt-10 me-n10" style="width: 4rem;">
                            <img style="opacity:0.5" class="img-fluid" src="/unify/assets/svg/components/pointer-up.svg" alt="Flourish 1">
                        </figure>
                        <!-- End SVG Shape -->
                        <!-- SVG Shape -->
                        <figure v-if="!BlockProps.HideFlourish" class="position-absolute bottom-0 start-0  ms-n10 mb-n10" style="width: 15rem;">
                            <img style="opacity:0.5" class="img-fluid" src="/unify/assets/svg/components/curved-shape.svg" alt="Flourish 2">
                        </figure>
                        <!-- End SVG Shape -->
                    </div>

                    <div class="text-center">
                        <p class="fs-6 text-muted mb-0">Prices in USD. Taxes may apply.</p>
                    </div>
                </div>
            </div>


        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertytogglededitor propertyname="HideFlourish" :blockprops="BlockProps" prompt="Hide Graphic Flourish Accents"></propertytogglededitor>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'CourierPricing',
        mixins: [ContentBlockBase],
        props: ['courierconfig'],
        components: {
        },
        computed:
        {
            CourierConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.courierconfig) {
                    return this.courierconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigCourier) {
                    return this.Store.TenantConfig.serviceConfigCourier;
                }               
            }
        },
        data() {
            return {  
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#CourierSettings'
            };
        },
        methods:
        {
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
        },

        setup(props, context)
        {             
            return {} 
        },
        created()
        {           
        },
        beforeUnmount()
        {
        },
        mounted() {
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

